export default __webpack_public_path__ + "static/study-4-ee878a2fad38c36eaaa4421b895b18ad.jpg";